module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/tactical-training-clan-landing-sm.9d4e26a3.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/tactical-training-clan-landing-sm.png
// module id = 3806
// module chunks = 11